import React, { useMemo } from 'react';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import WidgetsCommonColumns from 'components/widgets/components/WidgetsCommonColumns';
import { DateFormatter } from 'components/tables/NinjaTable/formatters';
import NinjaTable from 'components/tables/NinjaTable';

const DailyStatisticsCustomData = ({ innerId, dates }) => {
  const columns = useMemo(
    () => [
      {
        name: 'Date',
        key: 'date',
        width: 120,
        sortable: true,
        renderCell: DateFormatter,
        renderSummaryCell: () => {
          return 'Totals';
        },
      },
      ...WidgetsCommonColumns(),
      {
        key: 'deals_count',
        name: <span className='text-xs font-medium'>Deals</span>,
        renderCell: ({ row }) => {
          return getFormattedNumber(row.deals_count);
        },
        renderSummaryCell: ({ row }) => {
          return getFormattedNumber(row.deals_count);
        },
      },
      {
        key: 'leads_count',
        name: <span className='text-xs font-medium'>Leads</span>,
        renderCell: ({ row }) => {
          return getFormattedNumber(row.leads_count);
        },
        renderSummaryCell: ({ row }) => {
          return getFormattedNumber(row.leads_count);
        },
      },
    ],
    [innerId]
  );

  return (
    <NinjaTable
      columns={columns}
      date_key='adsetDailyStatisticsData'
      dataProvider='adsetDailyStatisticsData'
      cardProps={{ disable: true }}
      disableFooter={true}
      queryParams={{ filters: { ...dates, adset_id: innerId } }}
      maxHeight={400}
    />
  );
};

export default DailyStatisticsCustomData;
